import { IAnalysisItem } from "../../../Models/IAnalysisItem";
import { IGCPBigQueryJob } from "../../../Models/IGCPBigQueryJob";
import { IMyReportsReport } from "../../../Models/IMyReportsReport";
import { mapGcpJobsToAnalysisItems } from "../../../Util/ReportUtil";
import { IReportProgress } from "../Models/IReportProgress";
import {
    GET_RECENT_REPORTS_SUCCESS,
    GET_RECENT_MATCH_REPORTS_SUCCESS,
    GET_RECENT_MOBILYTICS_REPORTS_SUCCESS,
    GET_RECENT_REPORTS_FAILURE,
    GET_REPORTS_FAILURE,
    GET_REPORTS_SUCCESS,
    ReportActionType,
    SET_DELETING_REPORT,
    SET_DELETING_REPORT_SUCCESS,
    SET_LOADING_REPORTS,
    SET_REPORT_PROGRESS
} from "../Types/ReportActionTypes";

export interface IReportsReducerState {
    reports: IMyReportsReport[];
    loadingReports: boolean;
    deletingReport: boolean;
    isCollaborating: boolean;
    recentReports: IAnalysisItem[];
    recentMatchReports: IAnalysisItem[];
    recentMobilyticsReports: IAnalysisItem[];
    reportProgress: IReportProgress;
}

export const reportsReducerState: IReportsReducerState = {
    reports: [],
    loadingReports: false,
    deletingReport: false,
    isCollaborating: false,
    recentReports: [],
    recentMatchReports: [],
    recentMobilyticsReports: [],
    reportProgress: {
        progress: 0,
        verbiage: null,
        stageName: null
    }
};

export const reportsReducer = (
    state: IReportsReducerState = { ...reportsReducerState },
    action: ReportActionType
): IReportsReducerState => {
    switch (action.type) {
    /** misc */
        case SET_LOADING_REPORTS: {
            return {
                ...state,
                loadingReports: action.data as boolean,
            };
        }
        case SET_DELETING_REPORT: {
            return {
                ...state,
                deletingReport: action.data as boolean,
            };
        }
        case SET_REPORT_PROGRESS: {
            return {
                ...state,
                reportProgress: action.data as IReportProgress
            };
        }
        /** success */
        case GET_REPORTS_SUCCESS: {
            return {
                ...state,
                reports: action.data as IMyReportsReport[],
                loadingReports: false,
            };
        }
        case GET_RECENT_REPORTS_SUCCESS: {
            return {
                ...state,
                recentReports: mapGcpJobsToAnalysisItems(action.data as IGCPBigQueryJob[]),
                loadingReports: false,
            };
        }
        case GET_RECENT_MATCH_REPORTS_SUCCESS: {
            return {
                ...state,
                recentMatchReports: mapGcpJobsToAnalysisItems(action.data as IGCPBigQueryJob[]),
                loadingReports: false,
            };
        }
        case GET_RECENT_MOBILYTICS_REPORTS_SUCCESS: {
            return {
                ...state,
                recentMobilyticsReports: mapGcpJobsToAnalysisItems(action.data as IGCPBigQueryJob[]),
                loadingReports: false,
            };
        }
        case SET_DELETING_REPORT_SUCCESS: {
            return {
                ...state,
                deletingReport: false,
                reports: state.reports.filter(report => report.jobId !== action.data),
            };
        }
        /** failure */
        case GET_REPORTS_FAILURE:
        case GET_RECENT_REPORTS_FAILURE: {
            return {
                ...state,
                loadingReports: false,
            };
        }
        default: {
            return state;
        }
    }
};
